import type { CardImage } from '.cache/__types__';

export enum CardLayout {
  /** profile pic in banner */
  Layout_1A = '1A',
  /** logo pic in banner */
  Layout_1B = '1B',
  /** cover in banner */
  Layout_1C = '1C',
  /** profile pic in banner, logo floating */
  Layout_2A = '2A',
  /** logo in banner, profile floating */
  Layout_2B = '2B',
  /** cover in banner, profile floating */
  Layout_2C = '2C',
  /** cover in banner, logo floating */
  Layout_2D = '2D',
  /** cover in banner, profile floating, logo floating */
  Layout_3A = '3A',
}

export type ImageQuality = 'high' | 'low' | undefined;
export type ImageType = 'logo' | 'profile' | 'cover';
export type ImageFieldId = 'profile_picture' | 'cover_photo' | 'company_logo';
export type ImagePosition = 'left' | 'right' | 'banner';
export type CardAppearance = 'fit' | 'standalone';

export interface ShowPopover {
  position?: ImagePosition;
  type?: ImageType;
}

export interface ImageUrls {
  profile?: Partial<CardImage>;
  logo?: Partial<CardImage>;
  cover?: Partial<CardImage>;
  banner?: Partial<CardImage>;
  left?: Partial<CardImage>;
  right?: Partial<CardImage>;
}

export interface ImgBlob {
  blob: Blob | undefined;
  imageUrl: string | undefined;

  updateImageUrl: React.Dispatch<React.SetStateAction<string | undefined>>;
  resetImageUrl: () => void;
  error: boolean;
}
/** Blob information for all image types */
export interface ImgBlobs {
  profile: ImgBlob;
  logo: ImgBlob;
  cover: ImgBlob;
}

export type PlaceholderImageSize = 'normal' | 'small';
